import { Theme } from '@mui/material/styles';
import { useEffect } from 'react';

import { useAppDispatch } from '@/hooks/redux';

import { notifyUserChanged } from '@/redux/auth/actions';

import { FullPageLoaderOverlay } from '../Layout/FullPageLoader';

type UserRefresherProps = {
  className?: string;
  delayMs?: number;
  noLoader?: boolean;
};

export function UserRefresher({
  className,
  delayMs = 0,
  noLoader,
}: Readonly<UserRefresherProps>) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(notifyUserChanged());
    }, delayMs);

    return () => {
      clearTimeout(timer);
    };
  }, [delayMs, dispatch]);

  if (noLoader) return null;

  return (
    <FullPageLoaderOverlay
      className={className}
      bgColor={(theme: Theme) => theme.palette.background.paper}
    />
  );
}
